import React from 'react';

const Index = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  )
}

export default Index;
